import ThumbMenu from './thumb-menu';

export default ThumbMenu;
export { ThumbMenu };